
export const helpPage = '<!DOCTYPE html>'+
'<html lang="en">'+
'<head>'+
  '<title>restore-and-renew Help</title>'+
  '<meta charset="utf-8">'+
  '<meta name="viewport" content="width=device-width, initial-scale=1">'+
  '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css">'+
  '<!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>'+
  '<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.0/umd/popper.min.js"></script>'+
  '<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/js/bootstrap.min.js"></script>-->'+
  
  '<link rel="icon" type="image/x-icon" href="/static/favicon.ico">'+
  
  '<style>'+
    '@media print {'+
    
      '@page {'+
        'size: A4;'+
        'margin: 5mm;'+
      '}'+

      'html, body {'+
        'width: 1024px;'+
      '}'+

      'body {'+
        '/*margin: 0 auto;*/'+
        'font-size: 14px;'+
      '}'+

      '.container-fluid {'+
        'width: auto;'+
        'min-width: 750px;'+
      '}'+
    
      '.col-sm-12, .col-sm-6 {'+
        'float:left;'+
      '}'+
    
      '.col-sm-12 {'+
        'width: 40%;'+
      '}'+

      '.col-sm-6 {'+
        'width: 20%;'+
      '}'+
    '}'+
  '</style>'+
'</head>'+
'<body>'+

'<div class="container-fluid">'+

  '<div class="row py-4">'+
    '<div class="col-sm-8"><h1 style="color: #1C6293;">Welcome to the Restore & Renew webtool</h1></div>'+
    '<div class="col-sm-4"><img src="data/images/help/logo_small.png" alt="Restore and Renew logo" class="float-right"></div>'+
  '</div>'+

  '<div class="row py-2">'+
    '<div class="col-sm-12">'+
      '<h2 style="color: #1C6293;">What does the Restore & Renew webtool do?</h2>'+
      '<p>The webtool uses genetic, climatic and distributional information for selected plant species used in restoration. It is an ongoing project and new species will be added as the information becomes available.</p>'+
      '<p>For completed species at your selected site the tool provides:</p>'+
      '<ul>'+
        '<li>Site specific (selected by you) information on local genetic provenance of the selected species</li>'+
        '<li>Information on the current distribution of the selected species</li>'+
        '<li>A map indicating where current climatic conditions similar to those within your selected site are found</li>'+
        '<li>A map indicating where the conditions at your site in the future (2050) can be found <b>now</b>. This map represents conditions which will <i>come to your selected location by 2050</i>)</li>'+
        '<li>A printable summary document providing a brief description of the species selected, its distribution, predicted change in habitat availability, the geographic boundaries of local provenance based on your selected site, the distribution of climatic conditions that are similar to those at your site. Suggestions on how to apply this information within a range of restoration scenarios are also provide</li>'+
      '</ul>'+
      '<p>More information about the Restore &amp; Renew project is available <a href="https://www.rbgsyd.nsw.gov.au/science/restore-renew">here</a>, or email us at <a href="mailto:Restore.Renew@rbgsyd.nsw.gov.au">Restore.Renew@rbgsyd.nsw.gov.au</a>.</p>'+
      '<p><b>Please note:</b> The Restore &amp; Renew project uses species names from the National Species List (NSL) maintained by the Atlas of Living Australia. The plant names on the NSL are derived from the Australian Plant Census maintained by the Council of Heads of Australasian Herbaria (CHAH).</p>'+
    '</div>'+
  '</div>'+
  
  '<div class="row py-2">'+
    '<div class="col-sm-6">'+
      '<h2 style="color: #1C6293;">Using the Restore & Renew webtool</h2>'+
      '<p>The webtool has two components:</p>'+
      '<ol>'+
        '<li>an options and information panel, and,</li>'+
        '<li>an interactive map.</li>'+
      '</ol>'+

      '<p>Results are generated in three steps by choosing options in the left panel (area 1). Completing each step in the sequence will automatically move you to the next step. <strong>You can go back and change any of the options you select in previous steps at any time by clicking on the step.</strong> The results of the options you choose will be displayed live on the map to the right (area 2).</p>'+
    '</div>'+
  
    '<div class="col-sm-6">'+
      '<img src="data/images/help/Webtool_help_firstScreen_1_2_v2.png" alt="RandR webtool has 2 components" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">'+
    '</div>'+
  '</div>'+

  '<div class="row">'+
    '<div class="col-sm-12">'+
      '<h2 style="color: #1C6293;">The steps</h2>'+
    '</div>'+
  '</div>'+

  '<!-- Step 1 -->'+
  '<div class="row py-2">'+
    '<div class="col-sm-6">'+
      '<h4 style="color:#3871ac;">Step 1: Select a location</h4>'+
    
      '<p>Selecting a location places a blue marker on the map display (near red arrow in the next image). You can enter a location in three different ways:</p>'+
      '<ol>'+
        '<li>Move the map display and zoom in to see the region around your site, then click on the map at your site. Latitude and longitude will be read from the map.</li>'+
        '<li>Type in the decimal latitude and longitude in the text fields in the option panel.</li>'+
        '<li>Click in the "Find a place" box at the top-left of the map and enter a location name, or street address.</li>'+
      '</ol>'+

    '</div>'+
      
    '<div class="col-sm-6">'+
      '<img src="data/images/help/Webtool_Howto_locationMarker_circle.png" alt="Location selected showing blue marker" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">'+
    '</div>'+
  '</div>'+

  '<!-- Step 2 -->'+
  '<div class="row py-2">'+
    '<div class="col-sm-6">'+
      '<h4 style="color:#3871ac;">Step 2: Select a species</h4>'+
      '<p>Select from the species for which <b>data is available at your site</b> by:</p>'+
      '<ol>'+
        '<li>Using the pull-down list with your mouse (or arrow and enter keys)</li>'+
        '<li>Begin typing the species name until a match is found and then select your species.</li>'+
      '</ol>'+
      '<p>The list you see is trimmed automatically to show only those species for which data is available at your selected site. New species are being added to the Restore & Renew webtool as information becomes available (a list of the target species is available <a href="https://www.rbgsyd.nsw.gov.au/science/restore-renew/target-species-directory">here</a>) and the list available at your selected site will grow over time.</p>'+
    '</div>'+

    '<div class="col-sm-6">'+
      '<img src="data/images/help/Restore_and_Renew_HowTo_species_small.png" alt="Species selection list" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">'+
    '</div>'+
  '</div>'+

  '<!-- Step 3 -->'+
  '<div class="row py-2">'+
    '<div class="col-sm-6">'+
      '<h4 style="color:#3871ac;">Step 3: Review results</h4>'+
      '<p>Once you have completed step 2, the webtool will begin computing important spatial data which will be displayed on the map. Four items of data will be produced <i>for your selected location and species</i>:</p>'+
      '<ol>'+
        '<li><strong>Herbarium records</strong> will be indicated by red dots as a guide to the known distribution of the selected species</li>'+
        '<li><strong>Recommended collection area</strong> displays the local genetic provenance around your selected site. This is indicated by the highlighted area centred at your site and surrounded by a greyed area (the area outside the local genetic provenance)</li>'+
        '<li><strong>Similar environments (current)</strong> indicates areas which closely match the climate currently experienced at your selected location (purple highlights)</li>'+
        '<li><strong>Similar future environments (2050)</strong> displays areas with climatic conditions that are present in the landscape <i>now</i> and are similar to those expected to be at your selected site in 2050 (optional orange highlights – these are not displayed by default – first on right)</li>'+
      '</ol>'+
      '<p>The map legend in the <em>Results</em> section of the <em>Options</em> panel allows you to turn any of the displayed map layers on or off by clicking the check-boxes. For example, the second image shows the map display with the optional future environment match layer turned on.</p>'+
    '</div>'+

    '<div class="col-sm-6">'+
      '<div class="row py-2">'+
        '<img src="data/images/help/Webtool_howto_maplegend_default.png" alt="Review results" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">'+
      '</div>'+
      
      '<div class="row py-2">'+
        '<img src="data/images/help/Webtool_howto_maplegend_allSelected.png" alt="Check-boxes control layers displayed" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">'+
     '</div>'+
    '</div>'+
  '</div>'+
 
  '<!-- Other options -->'+
  '<div class="row py-2">'+
    '<div class="col-sm-12">'+
      '<h2 style="color: #1C6293;">Other options:</h2>'+
    '</div>'+
  '</div>'+

  '<div class="row py-2">'+
    '<div class="col-sm-6">'+
      '<h4 style="color:#3871ac;">Display detailed results</h4>'+
      '<p>The "Display results" button becomes active when you have successfully selected a location and species. Click on this button to see a detailed report including guidance on applying these results to one of several restoration scenarios. The report is displayed in a new tab so you will still be able to go back to the options and map display tab. You will also be able to click an option in the new tab to print the report or create a PDF.</p>'+

      '<h4 style="color:#3871ac;">Species background information</h4>'+
      '<p>After you have selected a species, an information icon will be displayed next to the species name. Clicking this will open a window with background information about the species. Links below the species name will open <strong>PlantNET</strong> and <strong>Atlas of Living Australia</strong> pages for the species. Each will be opened in a new tab.</p>'+

      '<h4 style="color:#3871ac;">Reset button</h4>'+
      '<p>Clicking on the “Reset” button at the bottom of the <i>Options</i> panel will clear all previous option selections and take you back to Step 1. Remember that if you want to keep the information you just obtained, press the “Display results” button to print or save a PDF before pressing the “Reset” button.</p>'+
    '</div>'+

    '<div class="col-sm-6">'+
        '<img src="data/images/help/Webtool_Howto_hover_over_display_results_cropped2_small.png" alt="Display results button active" class="float-left img-fluid border border-dark" style="box-shadow: 5px 5px 5px grey;">'+
    '</div>'+
  '</div>'+

'</div>'+
    
'<div class="row">'+
  '<div class="col-sm-12">'+
    '<hr>'+
    '<p style="text-align:center;">Copyright &copy; 2018 NSW Government</p>'+
  '</div>'+
'</div>'+
  
'</body>'+
'</html>';



// WEBPACK FOOTER //
// ./src/RandR.js